<template>
  <div style="padding: 0% 0px 1%;">
    <div class="titleTable">{{ text }}</div>
    <div class="cardTable">
      <v-data-table :headers="headers" :items="items" hide-actions>
        <template v-slot:items="props">
          <td class="text-code">{{ props.item.name }}</td>
          <td class="text-content">{{ props.item.description }}</td>
          <td class="text-xs-center">
            <v-chip class="fixed-chip" v-if="props.item.type" :color="typeColorFor(props.item.type)" :text-color="textColorForChip(props.item.type)">{{props.item.type}}</v-chip>
          </td>
          <td class="text-xs-center">
            <v-icon v-if="props.item.required" class="mdi-close-circle" style="color: #27DABC;">check_circle</v-icon>
          </td>
          <td class="text-xs-left" v-if="props.item.sample">
            {{props.item.sample}}
          </td>
          <td class="text-xs-center" v-if="props.item.requiredFor">
            {{ props.item.requiredFor }}
          </td>
        </template>
      </v-data-table>
    </div>
    <div class="text-footer-table">{{ notes }}</div>
  </div>
</template>

<script>
  export default {
    name: 'ParameterTable',
    props: {
      items: {
        type: Array,
        default: []
      },
      notes: {
        type: String
      },
      text: {
        type: String
      }
    },
    data(){
      return{
        headers: [
          { text: 'Field name', value: 'field_name', align: 'left', sortable: false },
          { text: 'Description', value: 'description', align: 'left', sortable: false },
          { text: 'Type', value: 'type', align: 'center', sortable: false },
          { text: 'Required', value: 'required', align: 'center', sortable: false },
        ]
      }
    },
    mounted() {
      let hasSample = false
      let hasRequiredFor = false

    for (let i in this.items) {
      if (this.items[i].sample) { hasSample = true }
      if (this.items[i].requiredFor) { hasRequiredFor = true }
    }

    if (hasSample) {
      this.headers.push({ text: 'Sample', value: 'sample', align: 'left', sortable: false })
    }

    if (hasRequiredFor) {
      this.headers.push({ text: 'Required For', value: 'required_for', align: 'center', sortable: false })
    }
  },
    methods: {
      typeColorFor(record) {
        return '#27DABC'
      },
      textColorForChip(record) {
        return '#2e4369'
      }
    }
  }
</script>

<style scoped>
.table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child) {
  white-space: normal!important;
}

.cardTable {
  padding: 0px 0x 0px 0px;
  box-shadow: 0px 0px 1px;
}

.titleTable {
  font-family: 'Paralucent';
  font-size: 14px;
  padding: 10px 0px;
  color: #2e4369;
}

.text-code {
  font-family: 'Courier New', Courier, monospace;
}

.text-content {
  font-family: 'Paralucent';
  font-size: 12px;
  padding: 10px 0px;
  color: #2e4369;
  letter-spacing: 0.5px;
}

.v-chip.fixed-chip {
  border-radius: 2px;
}

.text-footer-table {
  font-family: 'Paralucent';
  font-size: 12px;
  font-style: italic;
  margin: 5px 0px 15px;
}

</style>



// WEBPACK FOOTER //
// src/components/documentation/ParameterTable.vue